import React from "react"
import FunctionalLayout from "../components/layout/functionalLayout"
import SEO from "../components/seo"
import BaseForm from "../components/pages/baseForm"
import { createStore } from "redux"
import allReducer from "../redux/reducers"
import { Provider } from "react-redux"

/** Create redux store */
const store = createStore(
  allReducer
  // ,
  // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

const Index = () => (
  <Provider store={store}>
    <FunctionalLayout>
      <SEO title="HDB Fire Claim" />
      <BaseForm></BaseForm>
    </FunctionalLayout>
  </Provider>
)

export default Index
